import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Grid,
  IconButton,
  Tooltip
} from "@mui/material";
import { BsEyeFill, BsPencilSquare, BsTrashFill } from "react-icons/bs";
import Swal from "sweetalert2";
import usericon from './user.png'
import './main.css'
export default function InfoCard2({ img_type, icon, type, data, onClick, keys, onAction = () => { } }) {
  const cols = type === "user" ? [2, 10] : [4, 8];
  const handleClick = onClick || (() => { });

  const avatar = (type, data, keys) => {
    const imageSrc = data[keys[0]];
    if (type === "user") {
      return (
        <Box
          component="img"
          src={usericon}
          loading="lazy"
          alt=""
          sx={{
            width: '100%',
            objectFit: "cover",
            borderRadius: 2,

          }}
        />
      );
    }
    return (
      <Box
        component="img"
        src={imageSrc}
        loading="lazy"
        alt=""
        sx={{
          width: '100%',
          objectFit: "cover",
          borderRadius: 2,
        }}
      />
    );
  };

  return (
    <Card
      className="shadow"
      sx={{
        borderRadius: 1,
        p: 2,
        cursor: "pointer",
        position: 'relative'
      }}
      onClick={handleClick}
    >
      <Box color={'blue'} display={'flex'} gap={0.2} justifyContent={'end'}
        sx={{ position: 'absolute', right: 0, px: 2 }}>
        <IconButton onClick={() => onAction("More", data)} size="medium">
          <BsEyeFill fontSize={12} />
        </IconButton>
        <IconButton onClick={() => onAction("Edit", data)} size="small">
          <BsPencilSquare fontSize={12} />
        </IconButton>
        <IconButton
          onClick={(e) => {
            e.stopPropagation(); // Prevent card click
            Swal.fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, delete it!"
            }).then((result) => {
              if (result.isConfirmed) {
                onAction("Delete", data);
              }
            });
          }}
          size="small"
        >
          <BsTrashFill fontSize={12} />
        </IconButton>
      </Box>
      <Box display={'flex'} gap={2} alignItems={'center'}>
        <Box className="social-img-wrap">
          <Box className="social-img">
            {icon ? icon : avatar(type, data, keys)}
          </Box>
        </Box>
        <Box>
          <Tooltip title={data[keys[1]]} arrow placement="top">
            <Typography
              sx={{
                //my: 0.5,
                fontSize: 12,
                fontWeight: 600,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                display: "block",
                maxWidth: "100%"
              }}
            >
              {data[keys[1]]}
            </Typography>
          </Tooltip>
          <Typography sx={{ my: 0.5 }} fontSize={11} color="#848789cc">{data[keys[2]]}</Typography>
        </Box>
      </Box>
      <Box>

        <Box display={'flex'} alignItems={'center'} gap={2} justifyContent={'center'}>
          <Box>
            <Typography fontSize={20} fontWeight={700}>{data[keys[5]]}</Typography>
            <Typography fontSize={11} color="#848789cc">{keys[4]}</Typography>
          </Box>|
          <Box>
            <Typography fontSize={20} fontWeight={700}>{data[keys[7]] || 0}</Typography>
            <Typography fontSize={11} color="#848789cc">{keys[6]}</Typography>
          </Box>|
          <Box>
            <Typography fontSize={20} fontWeight={700}>{data[keys[9]]}</Typography>
            <Typography fontSize={11} color="#848789cc">{keys[8]}</Typography>
          </Box>
        </Box>
      </Box>
    </Card >
  );
}
